"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: 22,
      width: 22
    },
    display: "block",
    fill: "currentcolor"
  }, props), __jsx("path", {
    d: "M11.667 0l-.001 1.666h8.667V0h2v1.666h6a2 2 0 011.995 1.851l.005.15v15.919a2 2 0 01-.467 1.284l-.118.13L21 29.748a2 2 0 01-1.238.578l-.176.007H6.666a5 5 0 01-4.995-4.783l-.004-.217V3.667a2 2 0 011.85-1.995l.15-.005 5.999-.001V0zm16.666 11.666H3.667v13.667a3 3 0 002.823 2.995l.177.005h10.999v-5.666a5 5 0 014.784-4.996l.217-.004 5.666-.001zm-.081 8h-5.585a3 3 0 00-2.995 2.824l-.005.177-.001 5.586zm-18.586-16h-6v6h24.667v-6h-6v1.667h-2V3.666h-8.667v1.667h-2z"
  }));
}
var _default = exports.default = SvgComponent;